import React from "react";

// Lib
import { shallowEqual } from "react-redux";
import { useAppSelector } from "lib/hooks/useDispatch";

// Classname
import clsx from "clsx";

// components
import Preloader from "components/UiKit/Loader";

export const Container = () => {
  const { showLoader, isTransparent } = useAppSelector((store) => store.loader, shallowEqual);

  const cn = clsx("smart-loader", showLoader ? "smart-loader--active" : "", isTransparent ? "smart-loader__transparent" : "");

  return (
    <div className={cn}>
      <Preloader type="global" />
    </div>
  );
};

export default Container;
